import React from 'react';
import SEOHead from '@/components/marketing/SEOHead';
import PageHeader from '@/components/marketing/PageHeader';
import CTASection from '@/components/marketing/CTASection';
import FormatCard from '@/components/marketing/FormatCard';
import { FORMATS } from '@/data/site-content';
import { breadcrumbJsonLd } from '@/lib/jsonld';

export default function AdFormatsIndex() {
  const jsonLd = breadcrumbJsonLd([
    { label: 'Home', path: '/' },
    { label: 'Ad Formats' },
  ]);
  return (
    <>
      <SEOHead path="/ad-formats" jsonLd={jsonLd} />
      <PageHeader breadcrumbs={[{ label: 'Ad Formats' }]} eyebrow="Traffic Formats" title="Pick the right format for every offer" subtitle="Six curated performance formats with source-level controls, GEO targeting, and tracker compatibility built in." />
      <section className="bg-[#07111F] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {FORMATS.map((f) => <FormatCard key={f.slug} format={f} />)}
          </div>
        </div>
      </section>
      <CTASection eyebrow="Need a recommendation?" title="Not sure which format fits your offer?" subtitle="Apply as advertiser and pick “Not Sure / Need Recommendation”. We’ll guide you to the right setup." />
    </>
  );
}
